import React from 'react';
import { DCBUnsubscribe as DCBUnsubscribeScreen } from '@features/dcb-unsubscribe';

export const DCBUnsubscribe = (props: any) => <DCBUnsubscribeScreen {...props} />;
